export default __webpack_public_path__ + "static/media/1671.41bf7621.png";